/*
 * ZAP 2026-07-30 (De'Shan): Zena brand mark.
 * Adds a superscript "AI" after every standalone "Zena" in visible text, so the brand renders as
 * "Zena^AI" site-wide, matching the hero H1's manual treatment (Zena + sup, weight 900 in headings).
 *
 * Rules:
 *  - Matches the whole word "Zena" only (\bZena\b), so it never touches "Zenyth" or partial words.
 *  - Each processed "Zena" is wrapped in <span class="zena-mark">Zena<sup class="zena-ai">AI</sup></span>.
 *    Idempotent: any "Zena" already inside a .zena-mark is skipped, so re-runs (theme editor, section
 *    hydration, morphs) can never double-mark it.
 *  - A "Zena" already immediately followed by a <sup> (the hero H1's own manual sup) is left untouched.
 *  - Skips script/style/pre/code/inputs/svg.
 *  - Re-runs on DOM changes with the observer disconnected during the pass so it never triggers itself.
 * Styling lives in zap-styles.css (.zena-ai, .zena-mark, and h2 .zena-ai for the heavier heading weight).
 * Remove this file + its <script> tag + the .zena-ai/.zena-mark CSS to fully revert.
 */
(function () {
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, SUP: 1, NOSCRIPT: 1, SVG: 1 };
  var RE = /\bZena\b/g;

  function eligible(node) {
    if (!node.nodeValue || node.nodeValue.indexOf('Zena') === -1) return false;
    var p = node.parentNode;
    while (p && p.nodeType === 1) {
      if (SKIP[p.tagName]) return false;
      if (p.classList && (p.classList.contains('zena-mark') || p.classList.contains('zena-ai') || p.classList.contains('zap-nhero__sup'))) return false;
      p = p.parentNode;
    }
    return true;
  }

  function process(node) {
    var text = node.nodeValue;
    RE.lastIndex = 0;
    if (!RE.test(text)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0, m, changed = false;
    while ((m = RE.exec(text))) {
      var start = m.index, end = start + m[0].length;
      var trailing = end === text.length;
      var nextIsSup = trailing && node.nextElementSibling && node.nextElementSibling.tagName === 'SUP';
      frag.appendChild(document.createTextNode(text.slice(last, start)));
      if (nextIsSup) {
        // "Zena" already carries a superscript (e.g. the hero H1) - leave it as plain text.
        frag.appendChild(document.createTextNode(m[0]));
      } else {
        var mark = document.createElement('span');
        mark.className = 'zena-mark';
        mark.appendChild(document.createTextNode(m[0]));
        var sup = document.createElement('sup');
        sup.className = 'zena-ai';
        sup.textContent = 'AI';
        mark.appendChild(sup);
        frag.appendChild(mark);
        changed = true;
      }
      last = end;
    }
    frag.appendChild(document.createTextNode(text.slice(last)));
    if (changed) node.parentNode.replaceChild(frag, node);
  }

  function run() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) { if (eligible(n)) nodes.push(n); }
    for (var i = 0; i < nodes.length; i++) process(nodes[i]);
  }

  var observer, timer;
  function observe() {
    if (!observer) {
      observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          observer.disconnect();
          run();
          observer.observe(document.body, { childList: true, subtree: true });
        }, 150);
      });
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() { run(); observe(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
